import { Button, Card, IconButton, Typography } from "@mui/material";
import { FC } from "react";
import styled from "@emotion/styled";
import { Add, Edit } from "@mui/icons-material";
import { useModal } from "../../../../hooks/useModal";
import EditDescriptionForm from "../../../../components/forms/furniture/EditDescriptionForm";
import ReactMarkdown, { Components } from "react-markdown";


const LeftCard = styled(Card)`
    width: 600px;
    max-width: calc(100% - 40px);
    padding: 20px;

    @media screen and (max-width: 940px){
        width: calc(100% - 40px);
    }
`


const SectionHeader = styled(Typography)`
    font-weight: bold;
    font-size: 1.2rem;
    margin: 0;
    padding: 0;
`


interface DescriptionComponentProps {
    description?: string | null;
    showEditTools: boolean;
    furnitureId: string;
    onRefreshFurniture: () => void;
}

const DescriptionComponent: FC<DescriptionComponentProps> = ({
    description,
    showEditTools,
    furnitureId,
    onRefreshFurniture,
}) => {
    const modal = useModal()

    if (!description) return (
        showEditTools ?
            <LeftCard sx={{
                mt: 2,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
            }}>
                <Button
                    variant="outlined"
                    startIcon={<Add />}
                    color="success"
                    onClick={() => modal.open(
                        <EditDescriptionForm
                            furnitureId={furnitureId}
                            descriptionValue={description}
                            onRefreshFurniture={onRefreshFurniture}
                        />
                    )}
                >
                    Dodaj opis
                </Button>
            </LeftCard>
            :
            <></>
    )

    const markdownComponents: Components = {
        h1: ({ children }) => (
            <SectionHeader>{children}</SectionHeader>
        ),
        p: ({ children }) => (
            <p style={{ margin: 0, padding: 0 }}>{children}</p>
        ),
    };

    return (
        <LeftCard sx={{ mt: 2 }}>
            <Typography variant='h6' sx={{ pb: 2 }}>
                {showEditTools &&
                    <IconButton
                        color='secondary'
                        onClick={() => modal.open(
                            <EditDescriptionForm
                                furnitureId={furnitureId}
                                descriptionValue={description}
                                onRefreshFurniture={onRefreshFurniture}
                            />
                        )}
                    >
                        <Edit />
                    </IconButton>
                }
                Opis:
            </Typography>
            <Typography variant='body1' sx={{ whiteSpace: 'pre-line' }}>
                <ReactMarkdown components={markdownComponents}>
                    {description}
                </ReactMarkdown>
            </Typography>
        </LeftCard>
    )
}

export default DescriptionComponent;